// extracted by mini-css-extract-plugin
export default {"btn":"Notification_btn__9xzGY","notificationBtn":"Notification_notificationBtn__uDU54"};